// Resource definition for React Admin
export const feeSchedulesResource = {
  name: '費用排程',
  fields: {
    id: 'ID',
    name: '名稱',
    entityType: '實體類型',
    entityId: '實體',
    entity: '實體',
    templateId: '費用範本',
    template: '範本',
    customStructure: '自訂結構',
    isActive: '使用中',
    active: '使用中',
    effectiveDate: '生效日期',
    effectiveFrom: '生效起始',
    effectiveUntil: '生效結束',
    expiryDate: '到期日期',
    priority: '優先級',
    currency: '貨幣',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    site: '充電站',
    loadGroup: '負載組',
    charger: '充電樁',
    hierarchy: '階層',
    selectEntity: '選擇 {type}',
    allLoadGroups: '所有負載組',
    noTemplate: '無範本',
    templateHelper: '選擇費用範本或使用自訂結構',
    priorityHelper: '數字越小優先級越高（1 = 最高）',
    entityName: '實體名稱',
    status: '狀態',
    indefinite: '無限期',
    duration: '持續時間',
    effectivePeriod: '有效期間',
    components: '組件',
    effectiveUntilHelper: '留空表示無限期排程',
    createdBy: '建立者',
    description: '說明',
  },
};

// Custom fee schedules translations
export const feeSchedules = {
  name: '費用排程',
  fields: {
    id: 'ID',
    name: '名稱',
    entityType: '實體類型',
    entityId: '實體',
    entity: '實體',
    templateId: '費用範本',
    template: '範本',
    customStructure: '自訂結構',
    isActive: '使用中',
    active: '使用中',
    effectiveDate: '生效日期',
    effectiveFrom: '生效起始',
    effectiveUntil: '生效結束',
    expiryDate: '到期日期',
    priority: '優先級',
    currency: '貨幣',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    site: '充電站',
    loadGroup: '負載組',
    charger: '充電樁',
    hierarchy: '階層',
    selectEntity: '選擇 {type}',
    allLoadGroups: '所有負載組',
    noTemplate: '無範本',
    templateHelper: '選擇費用範本或使用自訂結構',
    priorityHelper: '數字越小優先級越高（1 = 最高）',
    entityName: '實體名稱',
    status: '狀態',
    indefinite: '無限期',
    duration: '持續時間',
    effectivePeriod: '有效期間',
    components: '組件',
    effectiveUntilHelper: '留空表示無限期排程',
    createdBy: '建立者',
    description: '說明',
  },
  entityTypes: {
    site: '充電站',
    load_group: '負載組',
    charger: '充電樁',
  },
  list: {
    title: '費用排程',
    filters: {
      search: '按名稱搜尋',
      entityType: '實體類型',
      templateId: '範本',
      activeOnly: '僅使用中',
      site: '充電站',
    },
  },
  create: {
    title: '建立費用排程',
    subtitle: '為實體分配費用結構',
    infoMessage: '建立費用排程以為特定充電站、負載組或充電樁套用定價。優先級較高（數字較小）的排程將覆蓋優先級較低的排程。',
    basicInfo: '基本資訊',
    entitySelection: '實體選擇',
    feeConfiguration: '費用配置',
    feeConfig: '費用配置',
    scheduleConfig: '排程配置',
    schedule: '排程',
    nameHelper: '此費用排程的描述性名稱',
    entityHelper: '選擇此費用排程適用的實體',
    templateHelper: '選擇範本或建立自訂費用結構',
    effectiveDateHelper: '此費用排程生效的時間',
    expiryDateHelper: '此費用排程到期的時間（可選）',
    configurationOptions: '配置選項',
    useTemplate: '使用費用範本',
    useCustom: '自訂費用結構',
    customFees: '自訂費用結構',
    templateInfo: '使用範本將繼承所選範本的所有費用組件和費率。',
    customFeeWarning: '自訂費用結構需要手動配置所有定價組件。',
    priorityInfo: '優先級決定當多個排程套用到同一實體時哪個排程優先。',
    overlapWarning: '確保生效日期不會為同一實體建立衝突的排程。',
    backToList: '返回費用排程',
  },
  edit: {
    title: '編輯 %{name}',
    subtitle: '修改費用排程配置',
    basicInfo: '基本資訊',
    entitySelection: '實體選擇',
    feeConfiguration: '費用配置',
    schedule: '排程',
    scheduleConfig: '排程配置',
    feeConfig: '費用配置',
    useTemplate: '使用費用範本',
    customFees: '自訂費用結構',
    statusInfo: '狀態資訊',
    hasAdjustmentsWarning: '此排程有費用調整。某些設定無法修改。',
    entityChangeDisabled: '存在調整時無法更改實體',
    feeStructureChangeDisabled: '存在調整時無法更改費用結構',
    currentTemplate: '目前使用範本：{name} ({currency})',
    noTemplate: '未選擇範本',
    templateCannotChange: '建立後無法更改範本。若要使用不同的範本，請建立新的排程。',
    templateInfo: '使用範本將繼承所選範本的所有費用組件和費率。',
    customFeeWarning: '對自訂費用結構的更改將影響使用中的排程',
    priorityInfo: '數字越小優先級越高（1 = 最高）',
    overlapWarning: '檢查可能衝突的重疊排程',
    deleteSchedule: '刪除排程',
    deleteScheduleDescription: '永久刪除此費用排程',
    entityCannotChange: '建立後無法更改實體',
    backToList: '返回費用排程',
    nameHelper: '此費用排程的描述性名稱',
    effectiveDateHelper: '此費用排程生效的時間',
    expiryDateHelper: '此費用排程到期的時間（可選）',
  },
  show: {
    title: '費用排程詳情',
    subtitle: '查看排程配置和有效定價',
    basicInfo: '基本資訊',
    entityInfo: '實體資訊',
    entityType: '實體類型',
    entityName: '實體名稱',
    feeConfiguration: '費用配置',
    effectivePricing: '有效定價',
    scheduleStatus: '排程狀態',
    status: '狀態',
    metadata: '中繼資料',
    usingTemplate: '使用費用範本：%{name}',
    customConfiguration: '使用自訂費用配置',
    noFeeStructure: '未配置費用結構',
    noEnabledComponents: '此排程目前沒有啟用任何費用組件。',
    enabledComponents: '已啟用組件',
    component: '組件',
    configuration: '配置',
    specialDates: '特殊日期',
    specialDatesCount: '已配置 {count} 個特殊日期',
  },
  validation: {
    nameRequired: '排程名稱為必填',
    entityRequired: '實體選擇為必填',
    templateOrCustomRequired: '需要範本或自訂結構',
    effectiveDateRequired: '生效日期為必填',
    expiryAfterEffective: '到期日期必須在生效日期之後',
  },
  status: {
    active: '使用中',
    inactive: '未使用',
    future: '未來',
    expired: '已過期',
  },
  notifications: {
    created: '費用排程建立成功',
    updated: '費用排程更新成功',
    deleted: '費用排程刪除成功',
  },
};